// src/user.types.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["SUPER_ADMIN"] = "super_admin";
  UserRole2["ADMIN"] = "admin";
  UserRole2["PROFESSIONAL"] = "professional";
  UserRole2["USER"] = "user";
  return UserRole2;
})(UserRole || {});
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["ACTIVE"] = "active";
  UserStatus2["INACTIVE"] = "inactive";
  UserStatus2["PENDING"] = "pending";
  UserStatus2["WAITING_QUESTIONNAIRE"] = "waiting_questionnaire";
  UserStatus2["SUSPENDED"] = "suspended";
  return UserStatus2;
})(UserStatus || {});
var CURRENT_TERMS_VERSION = "2026-06";
var CURRENT_PRIVACY_VERSION = "2026-06";

// src/api.types.ts
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["UNAUTHORIZED"] = "UNAUTHORIZED";
  ErrorCode2["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
  ErrorCode2["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
  ErrorCode2["TOKEN_INVALID"] = "TOKEN_INVALID";
  ErrorCode2["REFRESH_TOKEN_INVALID"] = "REFRESH_TOKEN_INVALID";
  ErrorCode2["FORBIDDEN"] = "FORBIDDEN";
  ErrorCode2["INSUFFICIENT_PERMISSIONS"] = "INSUFFICIENT_PERMISSIONS";
  ErrorCode2["PASSWORD_CHANGE_REQUIRED"] = "PASSWORD_CHANGE_REQUIRED";
  ErrorCode2["ACCOUNT_SUSPENDED"] = "ACCOUNT_SUSPENDED";
  ErrorCode2["VALIDATION_ERROR"] = "VALIDATION_ERROR";
  ErrorCode2["INVALID_INPUT"] = "INVALID_INPUT";
  ErrorCode2["NOT_FOUND"] = "NOT_FOUND";
  ErrorCode2["ALREADY_EXISTS"] = "ALREADY_EXISTS";
  ErrorCode2["CONFLICT"] = "CONFLICT";
  ErrorCode2["PROFESSIONAL_SUSPENDED"] = "PROFESSIONAL_SUSPENDED";
  ErrorCode2["PROFESSIONAL_FISCAL_INCOMPLETE"] = "PROFESSIONAL_FISCAL_INCOMPLETE";
  ErrorCode2["INTERNAL_ERROR"] = "INTERNAL_ERROR";
  ErrorCode2["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
  ErrorCode2["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
  return ErrorCode2;
})(ErrorCode || {});
var HttpStatus = /* @__PURE__ */ ((HttpStatus2) => {
  HttpStatus2[HttpStatus2["OK"] = 200] = "OK";
  HttpStatus2[HttpStatus2["CREATED"] = 201] = "CREATED";
  HttpStatus2[HttpStatus2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpStatus2[HttpStatus2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatus2[HttpStatus2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatus2[HttpStatus2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatus2[HttpStatus2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatus2[HttpStatus2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatus2[HttpStatus2["GONE"] = 410] = "GONE";
  HttpStatus2[HttpStatus2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatus2[HttpStatus2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatus2[HttpStatus2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatus2[HttpStatus2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  return HttpStatus2;
})(HttpStatus || {});

// src/professional.types.ts
var VerificationStatus = /* @__PURE__ */ ((VerificationStatus2) => {
  VerificationStatus2["PENDING"] = "pending";
  VerificationStatus2["IN_REVIEW"] = "in_review";
  VerificationStatus2["VERIFIED"] = "verified";
  VerificationStatus2["REJECTED"] = "rejected";
  return VerificationStatus2;
})(VerificationStatus || {});
var SPECIALIZATIONS = [
  "Tarocchi e Cartomanzia",
  "Sibille Evolutive",
  "Oracoli Intuitivi",
  "Astrologia e Numerologia",
  "Mediumship e Sensitiva",
  "Rune (Saperi Nordici)",
  "Crescita Personale",
  "Business e Life Coaching",
  "Registri Akashici",
  "Cristalloterapia e Pendolo",
  "Amore e Relazioni",
  "Human Design & Gene Keys",
  "Grafologia Evolutiva Relazionale"
];

// src/permissions.types.ts
var Permission = /* @__PURE__ */ ((Permission2) => {
  Permission2["ADMIN_ACCESS"] = "admin:access";
  Permission2["USERS_VIEW"] = "users:view";
  Permission2["USERS_CREATE"] = "users:create";
  Permission2["USERS_UPDATE"] = "users:update";
  Permission2["USERS_DELETE"] = "users:delete";
  Permission2["USERS_MANAGE"] = "users:manage";
  Permission2["PROFESSIONALS_VIEW"] = "professionals:view";
  Permission2["PROFESSIONALS_CREATE"] = "professionals:create";
  Permission2["PROFESSIONALS_UPDATE"] = "professionals:update";
  Permission2["PROFESSIONALS_DELETE"] = "professionals:delete";
  Permission2["PROFESSIONALS_MANAGE"] = "professionals:manage";
  Permission2["PROFESSIONALS_VERIFY"] = "professionals:verify";
  Permission2["LEADS_VIEW"] = "leads:view";
  Permission2["ANALYTICS_VIEW"] = "analytics:view";
  Permission2["ANALYTICS_EXPORT"] = "analytics:export";
  Permission2["PROFILE_VIEW"] = "profile:own";
  Permission2["PROFILE_UPDATE"] = "profile:own:update";
  Permission2["DASHBOARD_ACCESS"] = "dashboard:access";
  Permission2["SETTINGS_VIEW"] = "settings:view";
  Permission2["SETTINGS_UPDATE"] = "settings:update";
  Permission2["SETTINGS_MANAGE"] = "settings:manage";
  return Permission2;
})(Permission || {});
var RolePermissions = {
  ["super_admin" /* SUPER_ADMIN */]: Object.values(Permission),
  ["admin" /* ADMIN */]: [
    "admin:access" /* ADMIN_ACCESS */,
    "users:view" /* USERS_VIEW */,
    "users:create" /* USERS_CREATE */,
    "users:update" /* USERS_UPDATE */,
    "users:manage" /* USERS_MANAGE */,
    "professionals:view" /* PROFESSIONALS_VIEW */,
    "professionals:create" /* PROFESSIONALS_CREATE */,
    "professionals:update" /* PROFESSIONALS_UPDATE */,
    "professionals:manage" /* PROFESSIONALS_MANAGE */,
    "professionals:verify" /* PROFESSIONALS_VERIFY */,
    "leads:view" /* LEADS_VIEW */,
    "analytics:view" /* ANALYTICS_VIEW */,
    "profile:own" /* PROFILE_VIEW */,
    "profile:own:update" /* PROFILE_UPDATE */,
    "dashboard:access" /* DASHBOARD_ACCESS */,
    "settings:view" /* SETTINGS_VIEW */,
    "settings:update" /* SETTINGS_UPDATE */
  ],
  ["professional" /* PROFESSIONAL */]: [
    "profile:own" /* PROFILE_VIEW */,
    "profile:own:update" /* PROFILE_UPDATE */,
    "dashboard:access" /* DASHBOARD_ACCESS */,
    "settings:view" /* SETTINGS_VIEW */
  ],
  ["user" /* USER */]: [
    "profile:own" /* PROFILE_VIEW */,
    "profile:own:update" /* PROFILE_UPDATE */,
    "dashboard:access" /* DASHBOARD_ACCESS */
  ]
};
function hasPermission(role, permission) {
  return RolePermissions[role]?.includes(permission) ?? false;
}
function hasAllPermissions(role, permissions) {
  return permissions.every((permission) => hasPermission(role, permission));
}
function hasAnyPermission(role, permissions) {
  return permissions.some((permission) => hasPermission(role, permission));
}
function getPermissionsForRole(role) {
  return RolePermissions[role] ?? [];
}

// src/wallet.types.ts
var WalletTransactionType = /* @__PURE__ */ ((WalletTransactionType2) => {
  WalletTransactionType2["RECHARGE"] = "recharge";
  WalletTransactionType2["CONSULTATION_CHARGE"] = "consultation_charge";
  WalletTransactionType2["FREE_MINUTES_CREDIT"] = "free_minutes_credit";
  WalletTransactionType2["REFUND"] = "refund";
  WalletTransactionType2["CALL_CHARGE"] = "call_charge";
  WalletTransactionType2["CHAT_CHARGE"] = "chat_charge";
  WalletTransactionType2["CREDIT_RESERVATION"] = "credit_reservation";
  WalletTransactionType2["RESERVATION_RELEASE"] = "reservation_release";
  WalletTransactionType2["RECHARGE_BONUS"] = "recharge_bonus";
  WalletTransactionType2["ADMIN_CREDIT"] = "admin_credit";
  WalletTransactionType2["CASHBACK_BONUS"] = "cashback_bonus";
  WalletTransactionType2["BIRTHDAY_BONUS"] = "birthday_bonus";
  WalletTransactionType2["REFERRAL_BONUS"] = "referral_bonus";
  WalletTransactionType2["BONUS_EXPIRED"] = "bonus_expired";
  return WalletTransactionType2;
})(WalletTransactionType || {});
var BonusSource = /* @__PURE__ */ ((BonusSource2) => {
  BonusSource2["WELCOME"] = "welcome";
  BonusSource2["RECHARGE_PACKAGE"] = "recharge_package";
  BonusSource2["FIRST_RECHARGE_PROMO"] = "first_recharge_promo";
  BonusSource2["CASHBACK"] = "cashback";
  BonusSource2["BIRTHDAY"] = "birthday";
  BonusSource2["REFERRAL_REFERRER"] = "referral_referrer";
  BonusSource2["REFERRAL_REFEREE"] = "referral_referee";
  BonusSource2["LEGACY"] = "legacy";
  BonusSource2["MANUAL"] = "manual";
  return BonusSource2;
})(BonusSource || {});
var BonusGrantStatus = /* @__PURE__ */ ((BonusGrantStatus2) => {
  BonusGrantStatus2["ACTIVE"] = "active";
  BonusGrantStatus2["CONSUMED"] = "consumed";
  BonusGrantStatus2["EXPIRED"] = "expired";
  return BonusGrantStatus2;
})(BonusGrantStatus || {});
var BONUS_VALIDITY_DAYS = 20;

// src/consultation.types.ts
var ConsultationStatus = /* @__PURE__ */ ((ConsultationStatus2) => {
  ConsultationStatus2["PENDING"] = "pending";
  ConsultationStatus2["ACTIVE"] = "active";
  ConsultationStatus2["COMPLETED"] = "completed";
  ConsultationStatus2["CANCELLED"] = "cancelled";
  return ConsultationStatus2;
})(ConsultationStatus || {});

// src/call.types.ts
var CallSessionStatus = /* @__PURE__ */ ((CallSessionStatus2) => {
  CallSessionStatus2["RINGING"] = "ringing";
  CallSessionStatus2["ACTIVE"] = "active";
  CallSessionStatus2["PAUSED"] = "paused";
  CallSessionStatus2["COMPLETED"] = "completed";
  CallSessionStatus2["MISSED"] = "missed";
  CallSessionStatus2["REJECTED"] = "rejected";
  CallSessionStatus2["FAILED"] = "failed";
  CallSessionStatus2["CANCELLED"] = "cancelled";
  return CallSessionStatus2;
})(CallSessionStatus || {});
var RECHARGE_GRACE_PERIOD_MS = 6e4;
var MANUAL_PAUSE_MAX_MS = 3e5;
var CallErrorCode = /* @__PURE__ */ ((CallErrorCode2) => {
  CallErrorCode2["INSUFFICIENT_CREDITS"] = "INSUFFICIENT_CREDITS";
  CallErrorCode2["PROFESSIONAL_OFFLINE"] = "PROFESSIONAL_OFFLINE";
  CallErrorCode2["PROFESSIONAL_BUSY"] = "PROFESSIONAL_BUSY";
  CallErrorCode2["PROFESSIONAL_NOT_FOUND"] = "PROFESSIONAL_NOT_FOUND";
  CallErrorCode2["ALREADY_IN_CALL"] = "ALREADY_IN_CALL";
  CallErrorCode2["CALL_NOT_FOUND"] = "CALL_NOT_FOUND";
  CallErrorCode2["UNAUTHORIZED"] = "UNAUTHORIZED";
  CallErrorCode2["RATE_NOT_CONFIGURED"] = "RATE_NOT_CONFIGURED";
  return CallErrorCode2;
})(CallErrorCode || {});
var CREDIT_LOW_MINUTES = 3;

// src/recharge.types.ts
var PROMO_RATE = 0.99;
var PROMO_MAX_RECHARGES = 1;
var PROMO_ENDING_MINUTES = 3;
var RECHARGE_PACKAGES = [
  { amount: 10, totalCredit: 17, bonus: 7 },
  { amount: 30, totalCredit: 50, bonus: 20 },
  { amount: 50, totalCredit: 80, bonus: 30 }
];

// src/call-tariff.ts
var EPSILON = 1e-4;
var round2 = (n) => Math.round(n * 100) / 100;
function isPromoRate(costPerMinute) {
  return Math.abs(costPerMinute - PROMO_RATE) < EPSILON;
}
function deriveCallTariffProvenance(input) {
  const rate = input.costPerMinute ?? 0;
  const billed = input.billedAmount ?? 0;
  const bonus = input.billedFromBonus ?? 0;
  const regular = input.billedFromRegular ?? 0;
  if (!input.connectedAt || billed <= EPSILON) {
    return { segments: [], mixed: false };
  }
  const cashCategory = isPromoRate(rate) ? "promo" : "standard";
  const segments = [];
  if (bonus <= EPSILON && regular <= EPSILON) {
    return { segments: [{ category: cashCategory, amount: round2(billed), ratePerMinute: rate }], mixed: false };
  }
  if (bonus > EPSILON) {
    segments.push({ category: "bonus", amount: round2(bonus), ratePerMinute: rate });
  }
  if (regular > EPSILON) {
    segments.push({ category: cashCategory, amount: round2(regular), ratePerMinute: rate });
  }
  return { segments, mixed: segments.length > 1 };
}
function summarizeCallTariffs(inputs) {
  const totals = /* @__PURE__ */ new Map();
  for (const input of inputs) {
    const { segments } = deriveCallTariffProvenance(input);
    if (segments.length === 0) continue;
    const minutes = (input.durationSeconds ?? 0) / 60;
    const segmentsTotal = segments.reduce((sum, s) => sum + s.amount, 0);
    for (const segment of segments) {
      const item = totals.get(segment.category) ?? {
        category: segment.category,
        count: 0,
        minutes: 0,
        amount: 0
      };
      const minutesShare = segmentsTotal > EPSILON ? minutes * (segment.amount / segmentsTotal) : minutes;
      item.count += 1;
      item.minutes = round2(item.minutes + minutesShare);
      item.amount = round2(item.amount + segment.amount);
      totals.set(segment.category, item);
    }
  }
  return Array.from(totals.values());
}

// src/chat.types.ts
var ChatMessageStatus = /* @__PURE__ */ ((ChatMessageStatus2) => {
  ChatMessageStatus2["SENT"] = "sent";
  ChatMessageStatus2["DELIVERED"] = "delivered";
  ChatMessageStatus2["READ"] = "read";
  return ChatMessageStatus2;
})(ChatMessageStatus || {});

// src/landingConfig.types.ts
var LandingSectionType = /* @__PURE__ */ ((LandingSectionType2) => {
  LandingSectionType2["NAVBAR"] = "navbar";
  LandingSectionType2["HERO"] = "hero";
  LandingSectionType2["BONUS"] = "bonus";
  LandingSectionType2["FEATURES"] = "features";
  LandingSectionType2["PROFESSIONALS"] = "professionals";
  LandingSectionType2["FOOTER"] = "footer";
  return LandingSectionType2;
})(LandingSectionType || {});

// src/payout.types.ts
var ProfessionalEarningStatus = /* @__PURE__ */ ((ProfessionalEarningStatus2) => {
  ProfessionalEarningStatus2["PENDING"] = "pending";
  ProfessionalEarningStatus2["ALLOCATED"] = "allocated";
  ProfessionalEarningStatus2["PAID"] = "paid";
  return ProfessionalEarningStatus2;
})(ProfessionalEarningStatus || {});
var PayoutStatus = /* @__PURE__ */ ((PayoutStatus2) => {
  PayoutStatus2["PENDING_CONFIRMATION"] = "pending_confirmation";
  PayoutStatus2["PENDING_PAYMENT"] = "pending_payment";
  PayoutStatus2["PAID"] = "paid";
  PayoutStatus2["CANCELLED"] = "cancelled";
  return PayoutStatus2;
})(PayoutStatus || {});
var PayoutDocumentType = /* @__PURE__ */ ((PayoutDocumentType2) => {
  PayoutDocumentType2["PROFORMA"] = "proforma";
  PayoutDocumentType2["RITENUTA"] = "ritenuta";
  return PayoutDocumentType2;
})(PayoutDocumentType || {});
var SignedReceiptStatus = /* @__PURE__ */ ((SignedReceiptStatus2) => {
  SignedReceiptStatus2["MISSING"] = "missing";
  SignedReceiptStatus2["UPLOADED"] = "uploaded";
  SignedReceiptStatus2["VERIFIED"] = "verified";
  return SignedReceiptStatus2;
})(SignedReceiptStatus || {});
var EarningType = /* @__PURE__ */ ((EarningType2) => {
  EarningType2["CALL"] = "call";
  EarningType2["CONVERSION"] = "conversion";
  return EarningType2;
})(EarningType || {});
var CONVERSION_BONUS_AMOUNT = 7;
var CONVERSION_WINDOW_HOURS = 12;

// src/fiscal.types.ts
var RegimeFiscale = /* @__PURE__ */ ((RegimeFiscale2) => {
  RegimeFiscale2["OCCASIONALE"] = "occasionale";
  RegimeFiscale2["FORFETTARIO"] = "forfettario";
  RegimeFiscale2["ORDINARIO"] = "ordinario";
  RegimeFiscale2["CON_CASSA"] = "con_cassa";
  RegimeFiscale2["ESTERO"] = "estero";
  return RegimeFiscale2;
})(RegimeFiscale || {});
var StatoProfilo = /* @__PURE__ */ ((StatoProfilo2) => {
  StatoProfilo2["ATTIVO"] = "attivo";
  StatoProfilo2["SOSPESO"] = "sospeso";
  StatoProfilo2["CONVERTITO"] = "convertito";
  return StatoProfilo2;
})(StatoProfilo || {});
var FISCAL_DOCUMENT_TYPES = [
  "ci_fronte",
  "ci_retro",
  "cf_fronte",
  "cf_retro",
  "visura"
];
var RegistroRitenutaStato = /* @__PURE__ */ ((RegistroRitenutaStato2) => {
  RegistroRitenutaStato2["DA_VERSARE"] = "da_versare";
  RegistroRitenutaStato2["VERSATA"] = "versata";
  return RegistroRitenutaStato2;
})(RegistroRitenutaStato || {});

// src/contract.types.ts
var CONTRACT_VERSION = "2026-05-07";
var C = "/contratti";
var CONTRACT_GROUPS = [
  {
    key: "contratto",
    title: "Contratto e allegati",
    consentLabel: "Ho letto e accetto il Contratto e i relativi allegati (NDA, Termini di Pagamento, Sicurezza Informatica)",
    docs: [
      { slug: "contratto-pacchetto-piva", title: "Pacchetto Contrattuale Klaro7 S.R.L.S.", file: `${C}/contratto-pacchetto-piva.pdf`, regime: "piva" },
      { slug: "contratto-modalita-provvisoria", title: "Contratto Consulente in Modalit\xE0 Provvisoria", file: `${C}/contratto-modalita-provvisoria.pdf`, regime: "occasionale" },
      { slug: "allegato-6-nda", title: "Allegato 6 \u2014 Accordo di Riservatezza (NDA)", file: `${C}/allegato-6-nda.pdf` },
      { slug: "allegato-7-payout-policy", title: "Allegato 7 \u2014 Termini di Pagamento (Payout Policy)", file: `${C}/allegato-7-payout-policy.pdf` },
      { slug: "allegato-8-sicurezza-informatica", title: "Allegato 8 \u2014 Policy sulla Sicurezza Informatica", file: `${C}/allegato-8-sicurezza-informatica.pdf` }
    ]
  },
  {
    key: "codiceEtico",
    title: "Codice Etico e Guida Collaboratori",
    consentLabel: "Ho letto e accetto il Codice Etico e la Guida Collaboratori",
    docs: [
      { slug: "codice-etico", title: "Codice Etico per i Collaboratori", file: `${C}/codice-etico.pdf` },
      { slug: "guida-collaboratori", title: "Guida Operativa Consulenti", file: `${C}/guida-collaboratori.pdf` }
    ]
  },
  {
    key: "regolamento",
    title: "Regolamento interno",
    consentLabel: "Ho letto e accetto le Condizioni Generali, l\u2019Informativa Privacy e la Policy Recensioni",
    docs: [
      { slug: "condizioni-generali", title: "Condizioni Generali", file: `${C}/condizioni-generali.pdf` },
      { slug: "privacy-cookie-policy", title: "Informativa Privacy e Cookie Policy", file: `${C}/privacy-cookie-policy.pdf` },
      { slug: "policy-recensioni", title: "Policy Recensioni e Moderazione", file: `${C}/policy-recensioni.pdf` }
    ]
  }
];
var CONTRACT_GROUP_KEYS = CONTRACT_GROUPS.map((g) => g.key);

// src/support.types.ts
var SupportConversationStatus = /* @__PURE__ */ ((SupportConversationStatus2) => {
  SupportConversationStatus2["OPEN"] = "open";
  SupportConversationStatus2["PENDING"] = "pending";
  SupportConversationStatus2["RESOLVED"] = "resolved";
  return SupportConversationStatus2;
})(SupportConversationStatus || {});
var SupportSenderRole = /* @__PURE__ */ ((SupportSenderRole2) => {
  SupportSenderRole2["PROFESSIONAL"] = "professional";
  SupportSenderRole2["SUPER_ADMIN"] = "super_admin";
  return SupportSenderRole2;
})(SupportSenderRole || {});

// src/user-support.types.ts
var UserSupportSenderRole = /* @__PURE__ */ ((UserSupportSenderRole2) => {
  UserSupportSenderRole2["USER"] = "user";
  UserSupportSenderRole2["SUPER_ADMIN"] = "super_admin";
  return UserSupportSenderRole2;
})(UserSupportSenderRole || {});
var UserSupportConversationStatus = /* @__PURE__ */ ((UserSupportConversationStatus2) => {
  UserSupportConversationStatus2["OPEN"] = "open";
  UserSupportConversationStatus2["PENDING"] = "pending";
  UserSupportConversationStatus2["RESOLVED"] = "resolved";
  return UserSupportConversationStatus2;
})(UserSupportConversationStatus || {});

// src/fraud.types.ts
var FraudFlagStatus = /* @__PURE__ */ ((FraudFlagStatus2) => {
  FraudFlagStatus2["OPEN"] = "open";
  FraudFlagStatus2["CONFIRMED"] = "confirmed";
  FraudFlagStatus2["DISMISSED"] = "dismissed";
  return FraudFlagStatus2;
})(FraudFlagStatus || {});
var FraudReasonCode = /* @__PURE__ */ ((FraudReasonCode2) => {
  FraudReasonCode2["SHARED_DEVICE"] = "SHARED_DEVICE";
  FraudReasonCode2["SHARED_IP"] = "SHARED_IP";
  FraudReasonCode2["EMAIL_ALIAS"] = "EMAIL_ALIAS";
  FraudReasonCode2["EMAIL_TOKEN"] = "EMAIL_TOKEN";
  FraudReasonCode2["PHONE_REUSED"] = "PHONE_REUSED";
  FraudReasonCode2["FAST_FIRST_CALL"] = "FAST_FIRST_CALL";
  FraudReasonCode2["BONUS_ONLY_PATTERN"] = "BONUS_ONLY_PATTERN";
  return FraudReasonCode2;
})(FraudReasonCode || {});

// src/seo.types.ts
var SEO_PAGE_KEYS = [
  "/",
  "/consulenti",
  "/guide",
  "/faq",
  "/chi-siamo",
  "/carta-valori",
  "/codice-etico",
  "/come-selezioniamo-i-consulenti",
  "/lavora-con-noi",
  "/condizioni-generali",
  "/privacy",
  "/cookie-policy",
  "/note-legali",
  "/risoluzione-controversie",
  "/policy-recensioni"
];

export { BONUS_VALIDITY_DAYS, BonusGrantStatus, BonusSource, CONTRACT_GROUPS, CONTRACT_GROUP_KEYS, CONTRACT_VERSION, CONVERSION_BONUS_AMOUNT, CONVERSION_WINDOW_HOURS, CREDIT_LOW_MINUTES, CURRENT_PRIVACY_VERSION, CURRENT_TERMS_VERSION, CallErrorCode, CallSessionStatus, ChatMessageStatus, ConsultationStatus, EarningType, ErrorCode, FISCAL_DOCUMENT_TYPES, FraudFlagStatus, FraudReasonCode, HttpStatus, LandingSectionType, MANUAL_PAUSE_MAX_MS, PROMO_ENDING_MINUTES, PROMO_MAX_RECHARGES, PROMO_RATE, PayoutDocumentType, PayoutStatus, Permission, ProfessionalEarningStatus, RECHARGE_GRACE_PERIOD_MS, RECHARGE_PACKAGES, RegimeFiscale, RegistroRitenutaStato, RolePermissions, SEO_PAGE_KEYS, SPECIALIZATIONS, SignedReceiptStatus, StatoProfilo, SupportConversationStatus, SupportSenderRole, UserRole, UserStatus, UserSupportConversationStatus, UserSupportSenderRole, VerificationStatus, WalletTransactionType, deriveCallTariffProvenance, getPermissionsForRole, hasAllPermissions, hasAnyPermission, hasPermission, isPromoRate, summarizeCallTariffs };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map